import styled from 'styled-components';
import { motion } from 'framer-motion';

export const AboutContainer = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	padding: 0 20px;
	padding-top: 80px;
	
	@media screen and (max-width: 768px) {
		padding: 0 15px;
		padding-top: 120px; /* Espacio para la navbar fija */
	}
	
	@media screen and (max-width: 480px) {
		padding: 0 10px;
		padding-top: 100px; /* Espacio para la navbar fija en móviles pequeños */
	}
`;

export const AboutHero = styled.div`
	background: linear-gradient(135deg, #066a67 0%, #066a67 100%);
	padding: 80px 0;
	text-align: center;
	color: white;
	border-radius: 10px;
	margin-bottom: 60px;
	
	@media screen and (max-width: 768px) {
		padding: 40px 0;
		margin-bottom: 40px;
	}
	
	@media screen and (max-width: 480px) {
		padding: 30px 0;
		margin-bottom: 30px;
	}
`;

export const AboutTitle = styled.h1`
	font-size: clamp(2.5rem, 5vw, 4rem);
	font-weight: 700;
	margin-bottom: 20px;
	letter-spacing: 2px;
	
	@media screen and (max-width: 768px) {
		font-size: clamp(2rem, 6vw, 3rem);
		letter-spacing: 1px;
	}
	
	@media screen and (max-width: 480px) {
		font-size: clamp(1.8rem, 8vw, 2.5rem);
		margin-bottom: 15px;
	}
`;

export const AboutSubtitle = styled.p`
	font-size: 1.2rem;
	opacity: 0.9;
	max-width: 600px;
	margin: 0 auto;
	line-height: 1.6;
	
	@media screen and (max-width: 768px) {
		font-size: 1.1rem;
		padding: 0 20px;
	}
	
	@media screen and (max-width: 480px) {
		font-size: 1rem;
		padding: 0 15px;
	}
`;

export const AboutContent = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 60px;
	margin-bottom: 80px;
`;

export const AboutSection = styled(motion.div)`
	background: white;
	border-radius: 15px;
	padding: 40px;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
	border-left: 5px solid #066a67;
	
	@media screen and (max-width: 768px) {
		padding: 30px 20px;
		border-radius: 10px;
	}
	
	@media screen and (max-width: 480px) {
		padding: 25px 15px;
		border-radius: 8px;
	}
`;

export const SectionTitle = styled.h2`
	font-size: 2rem;
	font-weight: 600;
	color: #066a67;
	margin-bottom: 25px;
	display: flex;
	align-items: center;
	gap: 15px;
	
	&::before {
		content: '';
		width: 4px;
		height: 30px;
		background: #066a67;
		border-radius: 2px;
	}
	
	@media screen and (max-width: 768px) {
		font-size: 1.5rem;
		margin-bottom: 20px;
		gap: 10px;
		
		&::before {
			width: 3px;
			height: 25px;
		}
	}
	
	@media screen and (max-width: 480px) {
		font-size: 1.3rem;
		margin-bottom: 15px;
		gap: 8px;
		
		&::before {
			width: 3px;
			height: 20px;
		}
	}
`;

export const SectionText = styled.p`
	font-size: 1.1rem;
	line-height: 1.8;
	color: #555;
	margin-bottom: 20px;
	text-align: justify;
	
	&:last-child {
		margin-bottom: 0;
	}
	
	@media screen and (max-width: 768px) {
		font-size: 1rem;
		line-height: 1.7;
		margin-bottom: 15px;
	}
	
	@media screen and (max-width: 480px) {
		font-size: 0.95rem;
		line-height: 1.6;
		margin-bottom: 12px;
		text-align: left;
	}
`;

export const ImageSection = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 40px;
	align-items: center;
	margin: 60px 0;
	
	@media screen and (max-width: 768px) {
		grid-template-columns: 1fr;
		gap: 30px;
		margin: 40px 0;
	}
	
	@media screen and (max-width: 480px) {
		gap: 25px;
		margin: 30px 0;
	}
`;

export const ImageWrapper = styled.div`
	position: relative;
	border-radius: 15px;
	overflow: hidden;
	box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
`;

export const AboutImage = styled.img`
	width: 100%;
	height: 400px;
	object-fit: cover;
	transition: transform 0.3s ease;
	
	&:hover {
		transform: scale(1.05);
	}
	
	@media screen and (max-width: 768px) {
		height: 300px;
	}
	
	@media screen and (max-width: 480px) {
		height: 250px;
	}
`;

export const ImageOverlay = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
	padding: 30px 20px 20px;
	color: white;
`;

export const ImageCaption = styled.p`
	font-size: 0.9rem;
	opacity: 0.9;
	margin: 0;
`;

export const ValuesSection = styled.div`
	background: #f8f9fa;
	padding: 60px 40px;
	border-radius: 15px;
	margin: 60px 0;
	
	@media screen and (max-width: 768px) {
		padding: 40px 20px;
		margin: 40px 0;
		border-radius: 10px;
	}
	
	@media screen and (max-width: 480px) {
		padding: 30px 15px;
		margin: 30px 0;
		border-radius: 8px;
	}
`;

export const ValuesGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
	gap: 30px;
	margin-top: 40px;
	
	@media screen and (max-width: 768px) {
		grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
		gap: 20px;
		margin-top: 30px;
	}
	
	@media screen and (max-width: 480px) {
		grid-template-columns: 1fr;
		gap: 15px;
		margin-top: 25px;
	}
`;

export const ValueCard = styled(motion.div)`
	background: white;
	padding: 30px;
	border-radius: 10px;
	text-align: center;
	box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
	transition: transform 0.3s ease, box-shadow 0.3s ease;
	
	&:hover {
		transform: translateY(-5px);
		box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
	}
	
	@media screen and (max-width: 768px) {
		padding: 25px 20px;
	}
	
	@media screen and (max-width: 480px) {
		padding: 20px 15px;
	}
`;

export const ValueIcon = styled.div`
	width: 60px;
	height: 60px;
	background: linear-gradient(135deg, #066a67, #066a67);
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto 20px;
	font-size: 1.5rem;
	color: white;
`;

export const ValueTitle = styled.h3`
	font-size: 1.3rem;
	font-weight: 600;
	color: #066a67;
	margin-bottom: 15px;
`;

export const ValueText = styled.p`
	font-size: 1rem;
	line-height: 1.6;
	color: #666;
`;

export const MissionSection = styled.div`
	background: linear-gradient(135deg, #066a67 0%, #066a67 100%);
	color: white;
	padding: 60px 40px;
	border-radius: 15px;
	text-align: center;
	margin: 60px 0;
	
	@media screen and (max-width: 768px) {
		padding: 40px 20px;
		margin: 40px 0;
		border-radius: 10px;
	}
	
	@media screen and (max-width: 480px) {
		padding: 30px 15px;
		margin: 30px 0;
		border-radius: 8px;
	}
`;

export const MissionTitle = styled.h2`
	font-size: 3rem;
	font-weight: 700;
	margin-bottom: 20px;
	letter-spacing: 3px;
	
	@media screen and (max-width: 768px) {
		font-size: 2.5rem;
		margin-bottom: 20px;
		letter-spacing: 2px;
	}
	
	@media screen and (max-width: 480px) {
		font-size: 2rem;
		margin-bottom: 15px;
		letter-spacing: 1.5px;
	}
`;

export const MissionText = styled.p`
	font-size: 1.3rem;
	line-height: 1.8;
	max-width: 800px;
	margin: 0 auto;
	opacity: 0.95;
	font-weight: 300;
	
	@media screen and (max-width: 768px) {
		font-size: 1.2rem;
		line-height: 1.7;
	}
	
	@media screen and (max-width: 480px) {
		font-size: 1.1rem;
		line-height: 1.6;
	}
`;

export const StatsSection = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
	gap: 30px;
	margin: 60px 0;
	
	@media screen and (max-width: 768px) {
		grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
		gap: 20px;
		margin: 40px 0;
	}
	
	@media screen and (max-width: 480px) {
		grid-template-columns: repeat(2, 1fr);
		gap: 15px;
		margin: 30px 0;
	}
`;

export const StatCard = styled.div`
	text-align: center;
	padding: 30px 20px;
	background: white;
	border-radius: 10px;
	box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
	
	@media screen and (max-width: 768px) {
		padding: 25px 15px;
	}
	
	@media screen and (max-width: 480px) {
		padding: 20px 10px;
	}
`;

export const StatNumber = styled.div`
	font-size: 3rem;
	font-weight: 700;
	color: #066a67;
	margin-bottom: 10px;
	
	@media screen and (max-width: 768px) {
		font-size: 2.5rem;
	}
	
	@media screen and (max-width: 480px) {
		font-size: 2rem;
	}
`;

export const StatLabel = styled.p`
	font-size: 1rem;
	color: #666;
	margin: 0;
	font-weight: 500;
	
	@media screen and (max-width: 768px) {
		font-size: 0.9rem;
	}
	
	@media screen and (max-width: 480px) {
		font-size: 0.8rem;
	}
`;